module.exports = __webpack_public_path__ + "static/img/alpha-list-project.a5f46de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/alpha-list-project.jpg
// module id = 0NNk
// module chunks = 1